<div class="d-flex align-items-center">
  <div
    class="player-type-icon mr-2 align-items-center"
    *ngIf="params.data?.playerTypeName != null"
  >
    <span *ngIf="isWebPlayer()" class="player-icon-svg">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
    </span>
    <ng-container *ngIf="!isWebPlayer()">
      <img [src]="params.data?.iconUrl" alt="" class="lightmode_img" />
      <img [src]="params.data?.iconUrl" alt="" class="darkmode_img" />
    </ng-container>
  </div>
  <div *ngIf="params.data?.playerTypeName != null" class="text-ellipsis">
    {{ params.data?.playerTypeName }}
  </div>
  <span *ngIf="params.data?.playerTypeName == null">-</span>
</div>
